import React, { useState } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { AiOutlineCloudDownload, AiOutlineCloudUpload } from "react-icons/ai";

export default function Bulkexport() {
  const [showModal, setShowModal] = useState(false);
  const [file, setFile] = useState(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setFile(e.dataTransfer.files[0]);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  return (
    <div>
      {/* Button with Tooltip */}
      <div className="group relative cursor-pointer">
        <div
          data-tooltip-id="main-tooltip"
          data-tooltip-content="Bulk Export"
          onClick={() => setShowModal(true)}
          className="text-sm  bg-gray-300 text-blue-700 shadow-sm font-semibold rounded-md px-2 py-2 flex gap-1 border items-center justify-center hover:text-white hover:bg-gray-600 transition-all"
        >
          <AiOutlineCloudDownload size={18} />
          Bulk Import
        </div>
      </div>

      <ReactTooltip
        id="main-tooltip"
        place="top"
        effect="solid"
        className="!text-[14px] !rounded-md !px-5 !py-[2px] !text-white z-20 shadow-md"
      />

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">

          <div className="  rounded-md shadow-xl w-[50%]  bg-white ">
            <h2 className="text-lg font-semibold mb-6 border-b shadow-md p-5 text-gray-800">Import Buyer Details</h2>

            {/* Dropzone */}
            <div
              onDrop={handleDrop}
              onDragOver={handleDragOver}
              className="border-2  border-dashed  border-gray-300 rounded-md p-11 text-center flex flex-col items-center justify-center w-[60%] ms-40 gap-2"
            >
              <AiOutlineCloudUpload size={40} className="text-gray-400" />
              <p className="text-gray-800 font-medium">
                Select a file or drag and drop here
              </p>
              <p className="text-sm text-gray-500">file size no more than 10 MB</p>

              <label className="cursor-pointer mt-2 inline-block">
                <input
                  type="file"
                  onChange={handleFileChange}
                  className="hidden"
                />
                <span className="border border-blue-400 text-blue-400 px-4 py-[5px] text-xs p-9 rounded hover:bg-blue-50">
                  SELECT FILE
                </span>
              </label>

              {file && (
                <p className="mt-2 text-sm text-green-600">{file.name}</p>
              )}
            </div>

            {/* Footer Buttons */}
            <div className="mt-6 flex justify-end gap-2   bg-slate-50 p-3 border-t border-t-gray-300 ">
              <button
                onClick={() => {
                  setShowModal(false);
                  setFile(null);
                }}
                className="px-4 py-1 rounded-md mr-2 hover:bg-gray-300 text-sm"
              >
                Cancel
              </button>
              <button
                disabled={!file}
                className={`px-4 py-2 rounded-md text-sm ${
                  file
                    ? "bg-blue-600 text-white hover:bg-blue-700 mr-2"
                    : "bg-white shadow-sm text-gray-300 mr-4 "
                }`}
              >
                Upload
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
